/** Define a React context named AppContext */

import { createContext } from "react";
import { Version } from "./types";

export interface AppContextValue {
  selectedVersions: Version[];
  showOriginal: boolean;
  showNew: boolean;
  showTwoColumns: boolean;
}

export const DEFAULT_VERSION: Version = "tldr";

export const AppContext = createContext<AppContextValue>({
  selectedVersions: [DEFAULT_VERSION],
  showOriginal: true,
  showNew: true,
  showTwoColumns: true,
});
